import React, { useEffect } from 'react';
import {Link} from 'react-router-dom';
import {Button, Container} from '@mui/material';
import CustomContainer from '../components/CustomContainer';
// import { useAuth0 } from '@auth0/auth0-react';



export const HelpView = (props) => {


  return (
    <Container
    sx={{textAlign: "center"}}>
      <Button 
        variant="contained"
        LinkComponent={Link}
        to={require("../documents/C3AdvisorGuide.pdf")}
        target="_blank"
      >
        View Help Docs 
      </Button>
    </Container>
  )
}

export default HelpView;